<div class="chart-container">
  <apx-chart
    *ngIf="isValidGraphOptions"
    [series]="graphOptions.series"
    [chart]="graphOptions.chart"
    [dataLabels]="graphOptions.dataLabels"
    [tooltip]="graphOptions.tooltip"
    [plotOptions]="graphOptions.plotOptions"
    [yaxis]="graphOptions.yaxis"
    [xaxis]="graphOptions.xaxis"
    [stroke]="graphOptions.stroke"
    [grid]="graphOptions.grid"
    [fill]="graphOptions.fill"
    [title]="graphOptions.title">
  </apx-chart>
  <div *ngIf="!isValidGraphOptions" class="no-data">
    Нет данных для отображения графика
  </div>
</div>
